import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="m18 15-6-6-6 6"/>
</svg>`;

const Dropdown = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='dropdown' svg={svg} {...props} />
  )
);

Dropdown.displayName = 'DropdownIcon';

export default Dropdown;
